import { forwardRef } from 'react';

/** Links inside the editor preview go nowhere (the preview is not a storefront). */
export const PreviewLink = forwardRef(({ to, href, children, ...rest }, ref) => (
  <a ref={ref} href={to || href} onClick={(e) => e.preventDefault()} {...rest}>{children}</a>
));
PreviewLink.displayName = 'PreviewLink';

/** Placeholder content for the app-filled sections inside the editor preview. */
export const PREVIEW_SLOTS = {
  featured: (p) => (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {Array.from({ length: Math.min(Number(p.limit) || 8, 4) }, (_, i) => <div key={i} className="h-28 rounded-lg bg-[var(--app-border)]" />)}
    </div>
  ),
  categories: <div className="flex flex-wrap gap-3">{['All products', 'Laptops', 'Phones', 'Accessories'].map((c) => <span key={c} className="rounded-lg border border-[var(--app-border)] px-3 py-2 text-sm">{c}</span>)}</div>,
};

/** Draft media → the public media URL the storefront uses. */
export const previewMedia = (ref) => (ref && ref.media_id != null ? `/api/public-media/${ref.media_id}` : null);
